module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/container-canvas/container-canvas.component.scss
// module id = ./src/app/modules/common-module/components/container-canvas/container-canvas.component.scss
// module chunks = 9